import React, { useContext, useEffect, useRef, useState } from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { DataContext } from '../../store/GlobalState'
import {
  Container,
  ContainerContent,
  DriversContent,
  DriversImg,
  DriversTitle,
} from './styles'

const RelatedScenarios = ({
  gid,
  scenarioSetId,
  relatedScenarios,
  isTitleNotShown,
}) => {
  const titleRef = useRef()
  const nameRef = useRef()
  const titleRef2 = useRef()
  const nameRef2 = useRef([])
  const {
    state: {
      groupRadarIdGlobalState: groupRadarIdGlobalStateStore,
      isTranslated,
      langForTransState,
    },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(null)
  const [originalText, setoriginalText] = useState([])

  // Fetch translations when isTranslated is true
  useEffect(() => {
    const fetcher = async () => {
      const [res1] = await Promise.all([
        fetcherAPI.translation('en', langForTransState, originalTitle),
      ])
      const res2 = await Promise.all(
        originalText.map((child) => {
          return fetcherAPI.translation('en', langForTransState, child)
        }),
      )

      settranslations({
        res1,
        res2,
      })
    }
    if (isTranslated && originalTitle && originalText.length) {
      fetcher()
    }
  }, [isTranslated, originalText, originalTitle, langForTransState])

  // Update nameRef2.current only when isTranslated is false and relatedScenarios have length
  useEffect(() => {
    if (!isTranslated && relatedScenarios?.length) {
      if (titleRef.current?.innerHTML && !titleRef2.current) {
        titleRef2.current = titleRef.current?.innerHTML
      }
      if (titleRef2.current && !originalTitle) {
        setoriginalTitle(titleRef2.current)
      }

      const phenList = Array.from(nameRef.current?.children ?? [])
      const namesOfPhencollection = phenList
        .map((child) => child?.querySelector('span'))
        .filter((name) => !!name)

      if (namesOfPhencollection.length) {
        nameRef2.current = namesOfPhencollection.map((el) => el.innerHTML)
        if (!originalText.length) {
          setoriginalText(nameRef2.current)
        }
      }
    }
  }, [isTranslated, relatedScenarios, originalTitle, originalText])

  return (
    <Container ref={nameRef}>
      {!!relatedScenarios && !!relatedScenarios.length && (
        <>
          {!isTitleNotShown && (
            <>
              {!isTranslated ? (
                <DriversTitle ref={titleRef}>Related scenarios</DriversTitle>
              ) : (
                <DriversTitle
                  ref={titleRef}
                  dangerouslySetInnerHTML={{
                    __html: translations?.res1?.data,
                  }}></DriversTitle>
              )}
            </>
          )}
          {relatedScenarios.map((scenario, i) => (
            <ContainerContent key={i} className="container-related-scenario">
              <button
                style={{
                  border: 'none',
                  background: 'transparent',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                className="scenario-link right"
                data-href={`fp-scenario-card/${
                  scenario?.content?.type === 'fp-scenario' ? 0 : gid
                }/${
                  scenario?.content?.type === 'fp-scenario'
                    ? undefined
                    : scenarioSetId
                }/${scenario?.id}`}
                data-uri={`fp-scenario-card/${
                  scenario?.content?.type === 'fp-scenario' ? 0 : gid
                }/${
                  scenario?.content?.type === 'fp-scenario'
                    ? undefined
                    : scenarioSetId
                }/${scenario?.id}`}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="8" fill="white" />
                  <path
                    d="M11.7647 7.71764L16 7.71764C15.8407 3.52305 12.4769 0.159288 8.28236 0V4.23529C8.38962 6.11231 9.88769 7.61038 11.7647 7.71764Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M8.28236 11.7647V16C12.4769 15.8407 15.8407 12.4769 16 8.28236H11.7647C9.88769 8.38962 8.38962 9.88769 8.28236 11.7647Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M4.23529 8.28236H0C0.159288 12.4769 3.52305 15.8407 7.71764 16V11.7647C7.61038 9.88769 6.11231 8.38962 4.23529 8.28236Z"
                    fill="#689AB9"
                  />
                  <path
                    d="M7.71764 4.23529V0C3.52305 0.159288 0.159288 3.52305 0 7.71764H4.23529C6.11231 7.61038 7.61038 6.11231 7.71764 4.23529Z"
                    fill="#689AB9"
                  />
                </svg>
              </button>
              <>
                {!isTranslated ? (
                  <DriversContent
                    className="scenario-link right"
                    data-href={`fp-scenario-card/${
                      scenario?.content?.type === 'fp-scenario' ? 0 : gid
                    }/${
                      scenario?.content?.type === 'fp-scenario'
                        ? undefined
                        : scenarioSetId
                    }/${scenario?.id}`}
                    data-uri={`fp-scenario-card/${
                      scenario?.content?.type === 'fp-scenario' ? 0 : gid
                    }/${
                      scenario?.content?.type === 'fp-scenario'
                        ? undefined
                        : scenarioSetId
                    }/${scenario?.id}`}>
                    {scenario?.content?.title}
                  </DriversContent>
                ) : (
                  <DriversContent
                    className="scenario-link right"
                    data-href={`fp-scenario-card/${
                      scenario?.content?.type === 'fp-scenario' ? 0 : gid
                    }/${
                      scenario?.content?.type === 'fp-scenario'
                        ? undefined
                        : gid
                    }/${scenario?.id}`}
                    data-uri={`fp-scenario-card/${
                      scenario?.content?.type === 'fp-scenario' ? 0 : gid
                    }/${
                      scenario?.content?.type === 'fp-scenario'
                        ? undefined
                        : gid
                    }/${scenario?.id}`}>
                    {translations?.res2[i]?.data}
                  </DriversContent>
                )}
              </>
            </ContainerContent>
          ))}
        </>
      )}
    </Container>
  )
}

export default RelatedScenarios
